import { doc, onSnapshot } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { db } from './firebaseConfig';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import './game.css';

function Home() {
    const navigate = useNavigate();
    const [isHomeOn, setIsHomeOn] = useState(false);

    useEffect(() => {

        const unsub = onSnapshot(doc(db, "home", "FkAGT2s9xDP9rsEY6PSw"), (doc) => {
    
          const data = doc.data();
    
          setIsHomeOn(Boolean(data?.isOn))
    
        });
    
        return () => unsub();
    
      }, []);

      

  return (
    <div className="game-shell">
        <div className="game-stage">
          <div className="game-panel">
            <p className="game-kicker">{isHomeOn ? "Live now" : "Caltrans History Trivia Ride"}</p>
            <h1 className="game-title">Are we there yet?</h1>
            <p className="game-subtitle">Tap start to join the trivia ride from this device.</p>
            <div>
              <Button size='large' variant='contained' onClick={() => { navigate("/start") }} to={'/start'}>Start</Button>
            </div>
          </div>
        </div>
    </div>
  )
}

export default Home
